import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.boltin.com';
const INVOICES_API_PATH = '/api/invoices';

const fetchInvoices = async (params = {}) => {
  const response = await axios.get(`${API_BASE_URL}${INVOICES_API_PATH}`, { params });
  return response.data;
};

const getInvoice = async (id) => {
  const response = await axios.get(`${API_BASE_URL}${INVOICES_API_PATH}/${id}`);
  return response.data.data;
};

const createInvoice = async (payload) => {
  const response = await axios.post(`${API_BASE_URL}${INVOICES_API_PATH}`, payload);
  return response.data.data;
};

const updateInvoice = async (id, payload) => {
  const response = await axios.put(`${API_BASE_URL}${INVOICES_API_PATH}/${id}`, payload);
  return response.data.data;
};

const deleteInvoice = async (id) => {
  await axios.delete(`${API_BASE_URL}${INVOICES_API_PATH}/${id}`);
  return id;
};

const addInvoiceNote = async (id, note) => {
  const response = await axios.post(`${API_BASE_URL}${INVOICES_API_PATH}/${id}/notes`, { note });
  return response.data.data;
};

const invoiceService = {
  fetchInvoices,
  getInvoice,
  createInvoice,
  updateInvoice,
  deleteInvoice,
  addInvoiceNote,
};

export default invoiceService;
